export const DRILL_DOWN_PRE_CLASS = 's2-drill-down';

export const STRATEGY_SHEET_TOOLTIP_PRE_CLASS = 's2-strategy-sheet-tooltip';
